export default "__VITE_ASSET__b4a2b878__"